/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Compact org-activity signal for talent-search cards.
 *
 * Counts cover accessible projects only (shared / owned / collaborated).
 * The UI should hide the indicator when all fields are empty / zero.
 */
export interface ProfileActivitySummary {
  job_count?: number;
  live_sequence_count?: number;
  last_contacted_at?: string | null;
}
